import { MESSAGES } from 'src/modules/common/constants';
import { memo } from 'react';
import { I18n } from 'src/modules/common/components/I18n/I18n.tsx';
import { LocalesEnum } from 'src/generated/operations.ts';
import { Price } from 'src/common/Price/Price';

type Props = {
    price: number | null;
    currency: string;
    locale: LocalesEnum;
}

export const Total = memo(({ price, locale, currency }: Props) => (
    <div className="vss-total">
        <p className="vss-total__text">
            <I18n messageId={MESSAGES.checkoutTotal}/>
        </p>

        <p className="vss-total__text">
            {price === null ? '\u2014' : (<Price currency={currency} price={price} locale={locale}/>)}
        </p>
    </div>
));
